const initBlock = async function( $block ) {
	const { Swiper } = await import( 'swiper' );
	const { Navigation, Scrollbar } = await import( 'swiper/modules' );
	await import( 'swiper/css/bundle' );

	const $slider = $block.find( '.history-slider' );
	const $sliderMain = $block.find( '.history-slider__main' );
	const $sliderNav = $block.find( '.section-history__slider-nav' );
	const $buttonNext = $sliderNav.find( '.slider-nav__next' );
	const $buttonPrev = $sliderNav.find( '.slider-nav__prev' );
	const $scrollbar = $slider.find( '.swiper-scrollbar' );

	const swiperHistoryParams = {
		modules: [Navigation, Scrollbar],
		navigation: {
			nextEl: $buttonNext[0],
			prevEl: $buttonPrev[0]
		},
		scrollbar: {
			el: $scrollbar[0],
			hide: false,
			draggable: true
		},
		init: false,
		loop: false,
		allowTouchMove: false,
		speed: 750,
		spaceBetween: 0,
		slidesPerView: 'auto',
		slidesPerGroup: 1,
		watchSlidesProgress: true
	};
	const swiperHistory = new Swiper( $sliderMain[0], swiperHistoryParams );
	swiperHistory.init();

	function historySlides() {
		const isTouchDevice = 'ontouchstart' in window || window.innerWidth < 1024;
		const $historySlides = $block.find( '.history-slide' );

		if ( !$historySlides.length ) {return;}

		$historySlides.off( 'mouseenter mouseleave click' );

		$historySlides.each( function() {
			const $historySlide = $( this );
			const $swiperSlide = $historySlide.closest( '.swiper-slide' );

			if ( isTouchDevice ) {
				$historySlide.on( 'click', function( e ) {
					e.stopPropagation();
					const isOpen = $historySlide.hasClass( 'is-expanded' );

					$historySlides.not( $historySlide ).removeClass( 'is-expanded' );

					if ( !isOpen ) {
						$historySlide.addClass( 'is-expanded' );
						$swiperSlide.addClass( 'is-expanded' );
						$sliderMain.addClass( 'is-expanded' );

						const slideRect = $swiperSlide[0].getBoundingClientRect();
						const sliderRect = $sliderMain[0].getBoundingClientRect();
						if ( slideRect.right > sliderRect.right ) {
							swiperHistory.slideNext();
						} else if ( slideRect.left < sliderRect.left ) {
							swiperHistory.slidePrev();
						}
					} else {
						$historySlide.removeClass( 'is-expanded' );
						$swiperSlide.removeClass( 'is-expanded' );
						$sliderMain.removeClass( 'is-expanded' );
					}
				} );
			} else {
				$historySlide.on( 'mouseenter', function() {
					$historySlide.addClass( 'is-expanded' );
					$swiperSlide.addClass( 'is-expanded' );
					$sliderMain.addClass( 'is-expanded' );
				} );
				$historySlide.on( 'mouseleave', function() {
					$historySlide.removeClass( 'is-expanded' );
					$swiperSlide.removeClass( 'is-expanded' );
					$sliderMain.removeClass( 'is-expanded' );
				} );
			}
		} );
	}

	historySlides();

	let resizeTimer = false;
	$( window ).on( 'resize', function() {
		clearTimeout( resizeTimer );
		resizeTimer = setTimeout( function() {
			historySlides();
			if ( swiperHistory ) {
				swiperHistory.update();
			}
		}, 500 );
	} );
};

app.loadBlock( initBlock, 'section-our-history', '.section-history' );

if ( module.hot ) {
	module.hot.accept();
}
